import { render, staticRenderFns } from "./ChangeCurrency.vue?vue&type=template&id=23fac1bf&scoped=true&"
import script from "./ChangeCurrency.vue?vue&type=script&lang=js&"
export * from "./ChangeCurrency.vue?vue&type=script&lang=js&"
import style0 from "./ChangeCurrency.vue?vue&type=style&index=0&id=23fac1bf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fac1bf",
  null
  
)

export default component.exports